import { z } from 'zod';

// Kebab-case: lowercase ASCII letters/digits separated by single hyphens.
// Matches the backend's COMPANY_SLUG_PATTERN — used for Gitea issue labels.
export const COMPANY_SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const companySlugSchema = z
  .string()
  .min(1, 'Company slug is required')
  .max(64, 'Company slug must be 64 characters or fewer')
  .regex(COMPANY_SLUG_REGEX, 'Must be kebab-case: lowercase letters, digits, and single hyphens');

export const customerCreateSchema = z.object({
  name: z.string().min(1, 'Name is required').max(255),
  email: z.string().email('Must be a valid email').max(255),
  password: z.string().min(12, 'Password must be at least 12 characters').max(255),
  companySlug: companySlugSchema,
  productScopes: z.array(z.string().min(1).max(100)).optional().default([]),
});

export type CustomerCreateForm = z.infer<typeof customerCreateSchema>;

export const resetPasswordSchema = z.object({
  password: z.string().min(12, 'Password must be at least 12 characters').max(255),
  temporary: z.boolean().default(true),
});

export type ResetPasswordForm = z.infer<typeof resetPasswordSchema>;

// Derive a kebab-case slug suggestion from a company name. Strips non-alphanumeric
// characters, lowercases, and collapses runs of separators into single hyphens.
export function deriveSlugFromName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
